// Components==============
import React, { createContext, useState } from 'react';
// =========================

type TooltipProps = {
  position?: 'top' | 'right' | 'bottom' | 'left' | 'bottom-right';
  content: string | React.ReactNode;
  noPointer?: boolean;
  clicked?: boolean;
};

export const initialTooltipProps: TooltipProps = {
  position: 'top',
  content: '',
  noPointer: false,
  clicked: false,
};

type TooltipContextType = {
  tooltipIsVisible: boolean;
  setTooltipIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tooltipPosition: { left: number; top: number };
  setTooltipPosition: React.Dispatch<
    React.SetStateAction<{ left: number; top: number }>
  >;
  tooltipProps: TooltipProps;
  setTooltipProps: React.Dispatch<React.SetStateAction<TooltipProps>>;
};

export const TooltipContext = createContext({} as TooltipContextType);

export default function TooltipContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [tooltipIsVisible, setTooltipIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
  const [tooltipProps, setTooltipProps] = useState<TooltipProps>(
    initialTooltipProps
  );

  return (
    <TooltipContext.Provider
      value={{
        tooltipIsVisible,
        setTooltipIsVisible,
        tooltipPosition,
        setTooltipPosition,
        tooltipProps,
        setTooltipProps,
      }}
    >
      {children}
    </TooltipContext.Provider>
  );
}
